// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CDP83d0AlixJRX {
  margin-right: 4px;
  padding: 2px 6px;
  font-size: 12px;
}
.rB9x0lByvq9DnK {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTag": `CDP83d0AlixJRX`,
	"boardTagSelected": `rB9x0lByvq9DnK`
};
export default ___CSS_LOADER_EXPORT___;
